import { useEffect } from 'react';

const GOOGLE_API_URL = 'https://maps.googleapis.com/maps/api/js';

const useGoogleAutocompleteScript = () => {
  useEffect(() => {
    // change env var to be REACT_APP_REACT_APP_GOOGLE_LOCATION_API_KEY while using local
    if (!window.google) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'google-autocomplete';
      script.src = `${GOOGLE_API_URL}?key=
        ${process.env.REACT_APP_GOOGLE_LOCATION_API_KEY}&libraries=places`;
      document.getElementsByTagName('body')[0].appendChild(script);
    }
  }, []);
};

export default useGoogleAutocompleteScript;
